const state = {
    rticleId: 1,
    couponId: 1,
    couponActioeId: {
    },
    pageNoRecord: true,//弃用，和支付冲突用了持久化模块
    recordLong: true,
    applePushShow: false,
    countDownIconShow: true,
    transferEquipmentList: [],
    initialSwipe: 0,
    proxyEquipmentList: [],
    globalProxyIpForm: [],
    instanceList: null,
    groupingForList: [],
    bannerList: [],
    homeDataFetchTime: 0,
    reminder: null,
    reminderShow: false,
    groupListData: [],
    discoverScrollTop: 0,

}
const mutations = {
    SET_BATCH_QUIPMENTID: (state, num) => {
        state.rticleId = num
    },
    SET_COUPON: (state, num) => {
        state.couponId = num
    },
    SET_COUPON_ACTIOE: (state, obj) => {
        state.couponActioeId = obj
    },
    SET_ETENTIONPOPUPSHOW: (state, bool) => {
        state.pageNoRecord = bool
    },
    SET_RECORDLONG: (state, bool) => {
        state.recordLong = bool
    },
    SET_APPLEPUSHSHOW: (state, bool) => {
        state.applePushShow = bool
    },
    SET_COUNTDOWNICONSHOW: (state, bool) => {
        state.countDownIconShow = bool
    },
    SET_TEANSFEREQUIPMENTLIST: (state, cover) => {
        state.transferEquipmentList = cover
    },
    SET_INITIALSWIPE: (state, num) => {
        state.initialSwipe = num
    },
    SET_PROXYEQUIPMENTLIST: (state, cover) => {
        state.proxyEquipmentList = cover
    },
    SET_GLOBALPROXYIPFORM: (state, cover) => {
        state.globalProxyIpForm = cover
    },
    SET_INSTANCELIST: (state, list) => {
        state.instanceList = list
    },
    SET_GROUPINGFORLIST: (state, list) => {
        state.groupingForList = list
    },
    SET_BANNERLIST: (state, list) => {
        state.bannerList = list
    },
    SET_HOMEDATA_FETCHTIME: (state, time) => {
        state.homeDataFetchTime = time
    },
    SET_REMINDER: (state, { reminder, show }) => {
        state.reminder = reminder
        state.reminderShow = show
    },
    SET_GROUPLIST_DATA: (state, list) => {
        state.groupListData = list
    },
    SET_DISCOVER_SCROLL_TOP: (state, num) => {
        state.discoverScrollTop = num
    },
}
export default {
    // 开启命名空间
    namespaced: true,
    mutations,
    state,
}